import { Controller } from "@hotwired/stimulus";
import { createTimeline } from "animejs";


export default class extends Controller {
    static values = {
        "color": String
    }

    click(e) {
        const coordinates = e.currentTarget.getBoundingClientRect();
        const circle = this.createCircle(
            e.clientX - coordinates.x,
            e.clientY - coordinates.y
        );
        e.currentTarget.prepend(circle);

        createTimeline({
            defaults: {
                duration: 300,
                ease: "easeOutQuart",
            },
        })
            .add(circle, {
                width: e.currentTarget.clientWidth * 2,
                height: e.currentTarget.clientWidth * 2,
            })
            .add(
                circle,
                {
                    opacity: 0,
                    onComplete: () => {
                        circle.remove();
                    }
                },
                "-=100",
            );
    }

    createCircle(px, py) {
        const circle = document.createElement("div");
        circle.classList.add("bg-" + this.colorValue);
        circle.style.borderRadius = "100%";
        circle.style.opacity = 0.075;
        circle.style.position = "absolute";
        circle.style.width = 0;
        circle.style.height = 0;
        circle.style.left = px + "px";
        circle.style.top = py + "px";
        circle.style.transform = "translate(-50%, -50%)";
        return circle;
    }
}